import { rmaItemsEquipmentMf, rmaItemsMf } from './detailsRma';

export type RmaModelMf = {
    id: number;
    companyId: number;
    rmaItems: rmaItemsMf[];
    rmaItemsEquipmentMf: rmaItemsEquipmentMf[];
    cnpjCompany: string;
    observacao: string;
    ssoId: string;
    statusId: number;
    user: UserMf;
    createdAt: Date;
};

export type RmaModelLiteMf = {
    addressId: any;
    id: number;
    companyId: number;
    address: AddressModelMf;
    valorInvoice: string;
    cnpjNota: string;
    statusCnpjCompany: number;
    statusCnpjNota: number;
    rmaItemsManufacturing: rmaItemsMf[];
    rmaItemsEquipmentManufacturing: rmaItemsEquipmentMf[];
    rmaManufacturingFile: rmaManufacturingFile[];
    observacao: string;
    acessorios: string;
    ssoId: string;
    shipping: string;
    package: PackageMf;
    statusId: number;
    name: string;
    typeId: number;
    generalMessage?: unknown;
    addressNumber: string;
    invoice: string;
    addressComplement: string;
    user: UserMf;
    justify?: string;
    status: InfoMf;
    type: InfoMf;
    rmaRequests: RmaRequestModelMf[];
    rmaChats: RmaChatModelMf[];
    createdAt: Date;
    rmaDeleted: RmaDeletedMf;
    workOrders: WorkOrderRmaLiteDtoMf[];
    Number: number;
    situation: string;
    numberPV: string;
    numberQuotation: string;
    nameResponsible: string;
    phoneResponsible: string;
    obf: Obf;
    //cfop: string;
};

export type Obf = {
    id?: number;
    rmaManufacturingId?: number;
    user?: string;
    data?: Date;
    semana?: number;
    obf?: boolean;
    causaRaiz?: string;
    categoria?: string;
    quantidade?: number;
    ssoId?: string;
    isPedidoCorresponde?: boolean;
};

export type RmaChatModelMf = {
    rmaId: number;
    userName: string;
    message: string;
    createdAt: string;
};
export type RmaFileModelMf = {
    id?: number;
    type?: string;
    fileName: string;
    rmaManufacturingId: number;
    createdAt: Date;
    contentType?: string;
    imageData?: string[];
};

export type rmaManufacturingFile = {
    id?: number;
    type?: string;
    fileName: string;
    rmaManufacturingId: number;
    createdAt: Date;
    contentType?: string;
    imageData?: string[];
};
export type RmaReportModelMf = {
    DateEnd?: any;
    DateStart?: any;
    Type?: any;
    SsoId?: number | string;
};
export type RmaFilterModelMf = {
    id?: number;
    dateStart?: Date;
    dateEnd?: Date;
    statusId?: number;
    serialNumber?: string;
    itemsByPage: number;
    indice: number;
    rmaManufacturing: RmaModelMf[];
    ssoId?: string;
    listSsoId?: string[];
    totalItems?: number;
    situation?: string;
    cnpjCompany?: string;
    cnpjNota?: string;
    nfHoneywell?: string;
    numberPV?: string;
    gbe?: string;
    nameCompany?: string;
};

export type RmaFilterReport = {
    tipoRelatorio: number;
    dataInicio?: Date | null;
    dataFim?: Date | null;
    pageNumber: number;
    pageSize: number;
    isExcel: boolean;
};

export type RMAFilterHistoryMf = {
    serialNumber?: string;
};
export type EOSFilterModelMf = {
    blockingLevel?: string;
    model?: string;
};

export type RmaRequestModelMf = {
    id?: number;
    rmaId: number;
    description: string;
    typeId: number;
    type: InfoMf;
    createdBy: UserMf;
    ssoId: string;
    finishedById?: number;
    isCompleted?: boolean;
    createdAt?: Date;
};

export type AddressModelMf = {
    zipCode: string;
    state: string;
    city: string;
    neighborhood: string;
    street: string;
    // number: string;
    // complement: string;
};

export type InfoMf = {
    id: number;
    name: string;
};

export type UserMf = {
    id: number;
    name: string;
    email: string;
    phone: string;
};

export type ShippingMf = {
    code: string;
    observation: string;
    situation: string;
    // transport: string,
    requestedByCustomer: boolean;
    typeId: number;
    type: InfoMf;
};

export type PackageMf = {
    id: number;
    height: string;
    length: string;
    materialType: string;
    name: string;
    date: Date;
    phone: string;
    time: string;
    weight: string;
    width: string;
};

export type RmaMessageModelMf = {
    readingBy: string;
    message: string;
    readingDate: number;
    date: string;
    userName: string;
};

export type RmaResultModelMf = {
    number: number;
    typeId: number;
    cnpjInvoice: string;
    statusId: number;
    qtdItems: number;
    persistDate: string;
};

export class RmaResultMf {
    number!: number;
    typeId!: number;
    cnpjInvoice!: string;
    statusId!: number;
    qtdItems!: number;
    persistDate!: string;
}

export type RmaLastEventsModelMf = {
    description: string;
    date: string;
    rmaId: number;
};

export type RmaRequestOpenModelMf = {
    description: string;
    date: string;
    rmaId: number;
};

export type CustomerModelMf = {
    id: string;
    phone: string;
    email: string;
    company: string;
    cnpj: string;
    user: string;
};

export type EquipmentModelMf = {
    status: number;
    equipment: string;
    equipmentDesc: string;
};

export type RmaDeletedMf = {
    RmaId: number;
    Reason?: string;
};

export type RmaDetailModelMf = {
    id: number;
    cnpjNota: string;
    valorInvoice: string;
    observacao: string;
    acessorios: string;
    addressComplement: string;
    addressNumber: string;
    status: {
        id: number;
        name: string;
    };
    type: {
        id: number;
        name: string;
    };
    address: {
        zipCode: string;
        city: string;
        state: string;
        neighborhood: string;
        street: string;
    };
    createdAt: Date;
    package: {
        name: string;
        phone: string;
        time: string;
        materialType: string;
        height: string;
        width: string;
        length: string;
        weight: string;
        date: Date;
    };
    shipping: {
        code: string;
        observation: string;
        situation: string;
        transport: string;
    };
    user: {
        name: string;
        email: string;
    };
    rmaItems: [];
    workOrders: WorkOrderModelMf[];

    //ANTIGO
    Number: number;
    UserId: number;
    UserName: string;
    UserEmail: string;
    UserPhone: string;
    CompanyId: number;
    CompanyName: string;
    CompanyCnpj: string;
    CnpjInvoice: string;
    PersistDate?: string;
    Nfe?: number | string;
    StatusId: number;
    TypeId: number;
    ShipmentRequested?: string;
    ShipmentRequestedCode?: number;
    AutorizeTypeRmaId: number;
    Accessories?: unknown;
    DiscountCouponNumber?: number;
    DiscountCouponId?: number;
    DiscountCouponPerCent?: number;
    Items: ItemRmaModelMf[];
    QtdItems: number;
    WorkOrderBudget: WorkOrderBudgerModelMf;
    QtdOSs: number;
    QtdOSWaitingApproval: number;
    ShippingDate: string;
    ShippingAddress: ShippingAddressModelMf;
    ShipmentShipping: ShipmentShippingModelMf;
    Files: FilesModelMf[];
    Events: EventsModelMf[];
    rmaChats: RmaChatModelMf[];
    Requests: RequestModelMf[];
    Notes: NotesModelMf[];
    SatisfactionSurveyModel: unknown;
    InvoicesValue: number | string;
    AutorizeTypeObs: unknown;
    Comments: unknown;
    LastUpdate: unknown;
    FlagIsPartnersCommissioning: boolean;
    FinalCustomerName?: unknown;
    FinalCustomerEmail?: unknown;
    ChangeToStatusId: number;
    ChangeToTypeId: number;
    GeneralMessage?: unknown;
    ActionObs?: unknown;
    HaveOS: number;
};

export type RequestModelMf = {
    FlagFinished?: boolean;
    CreatedBy?: string;
    Date?: string;
    Type?: string;
    Description?: string;
    CreatedById?: number;
    FinishedBy?: string;
    FlagViewed?: boolean;
    ViewedBy?: string;
    ViewedDate?: string;
    CompletionDate?: string;
    Id: string;
    RmaId: string;
    GenericId?: any;
};
export type NotesModelMf = {
    Message: string;
    SendBy: string;
    Date: string;
    Id: string;
};
export type EventsModelMf = {
    Id: number;
    RmaId: number;
    OsId?: unknown;
    Title: string;
    Type: string;
    Date: string;
    Description: string;
    FlagAdminMonitor?: null;
    AdminMonitorReporter?: null;
    AdminMonitorReporter_value?: null;
    AdminMonitorConfirmedBy?: null;
    AdminMonitorConfirmedBy_value?: null;
    AdminMoniorDateConfirmed?: null;
    RequestId?: null;
};

export type FilesModelMf = {
    AddedBy: string;
    Author: string;
    Date: string;
    Extension: string;
    Id: number;
    Name: string;
    NickName: string;
    RmaId: number;
    Type: string;
};
export type ItemRmaModelMf = {
    Id: number;
    RmaId: number;
    PartNumberModel: string;
    PartNumberDescription: any;
    SerialNumber: string;
    ProblemDescription: string;
    Approval: number;
    ApprovalDate: string;
    Observation: string;
    FlagErrorDetected: boolean;
    FlagServiceAuthorized: boolean;
    FlagProductFound: any;
    FlagProductWithoutSerialNumber: boolean;
    ErrorDetails: any;
    PartNumberType: string;
    IsEOS: boolean;
    Files: any[];
};

export type WorkOrderRmaLiteDtoMf = {
    rma: string;
    os: string;
    partnumber: string;
    modalidade: string;
    serial: string;
    status: string;
    dataEntrada: string;
    dataSaida: string;
    codigo: string;
    relatorio: boolean;
    flagApproved: number;
};

export type WorkOrderModelMf = {
    number: string;
    product: ProductRmaModelMf;
    issued: string;
    changes: ChangeRmaModelMf[];
    status: {
        code: string;
        description: string;
    };
    rma: {
        number: string;
        workOrders: string[];
    };
    technicalReport: string;
    accessory?: string;
    failureReported: string;
    factoryWarranty: boolean;
    serviceWarranty: boolean;
    badUse: boolean;
    entryInvoice: string;
    contract: {
        code: string;
    };
    saleDate: string;
    flagApproved: number;
    courierName: string;
    courierRegisterNumber: string;
    invoice: string;
    trackingCode: string;
    invoiceDate: Date;
};

export type ProductRmaModelMf = {
    code: string;
    number: string;
    description: string;
    serialNumber: string;
    modality: string;
    modalityCode: string;
};

export type ChangeRmaModelMf = {
    code: string;
    number: string;
    description: string;
    cause: string;
    optional: number;
    serviceType: number;
    NCM: string;
    quantity: number;
    ottp: string;
    reason: {
        code: string;
        description: string;
    };
};

export type WorkOrderBudgerModelMf = {
    budgetNumber?: number;
    oSNumber?: number;
    items?: BudgetItemsMf[] | any;
    currency: number;
    currencyRate: number;
    amount: number;
    amountTax: number;
    benefitPISCOFINS: boolean;
    amountPISCOF: number;
    benefitIPI: boolean;
    amountIPI: number;
    benefitICMS: boolean;
    amountICMS: number;
    amountISS: number;
    amountST: number;
    entryInvoice?: any;
    saleDate: string;
    paymentTerms: any;
    flagApproved: number;
    approvedUserName?: unknown;
    approvedPhone?: unknown;
    approvedPartsCnpj?: unknown;
    approvedServicesCnpj?: unknown;
    approvedPartsEmail?: unknown;
    approvedServicesEmail?: unknown;
    approvedEmailXml?: unknown;
    approvedObs?: unknown;
    approvedRequireOrderFile?: any | undefined;
    approvedSsoId?: unknown;
    approvedSalesOrder?: boolean;
};

export type ShippingAddressModelMf = {
    RmaId: number | string;
    Cep: string;
    State: string;
    City: string;
    Neighborhood: string;
    Street: string;
    Number: string;
    Complement?: string;
    ShippingDate: string;
};

export type ShipmentShippingModelMf = {
    RmaId: number;
    ResponsibleName: any;
    ResponsiblePhone: any;
    Height: any;
    Width: any;
    Length: any;
    Weight: any;
    Type: any;
    Quantity: any;
    BusinessHours: any;
    CollectionRequestDate: any;
    ShipmentRequestedCode: any;
};
export type RmaOptionMf = {
    value: number;
    text: string;
    color?: 'red' | 'yellow' | 'orange' | 'green' | 'blue' | 'grey';
};
export type WorkOrderOptionMf = {
    value: number[];
    text: string;
    color: 'red' | 'yellow' | 'orange' | 'green' | 'blue' | 'grey';
};

export type Categorias = {
    value: string;
    text: string;
};

export type RMAreportTypesMf = {
    text: string;
    value: number;
    restrict: boolean;
};

export type BudgetDetailsModelMf = {
    id?: number;
    number?: number;
    rmaId?: number;
    statusId?: number;
    partNumberCode?: unknown;
    partNumberDescription?: unknown;
    serialNumber?: unknown;
    dateRegistration?: unknown;
    defectFound?: unknown;
    technicalAdvice?: unknown;
    budgetFileName?: unknown;
    accessories?: unknown;
    lastUpdate?: unknown;
    budgetCurrency?: unknown;
    totalBudget?: unknown;
    flagAvailableBudget?: unknown;
    flagAutomaticUpdate?: false;
    services?: [];
    benefitPISCOFINS?: unknown;
    benefitIPI?: unknown;
    totalBudgetWithoutOptional?: unknown;
    flagPricesAvailable?: false;
    invoiceReturn?: unknown;
    invoiceInput?: unknown;
    priceDollar?: unknown;
    flagErrorDetected?: unknown;
    errorInfo?: unknown;
    reviewDate?: unknown;
    flagBudgetAproved?: unknown;
    totalAproved?: unknown;
    partNumberManufactureDate?: unknown;
    shippingDate?: unknown;
    invoiceIssueDate?: string | undefined;
    shippingCompany?: unknown;
    userId?: number;
    userName?: string;
    companyId?: number;
    companyName?: unknown;
    companyCnpj?: unknown;
    invoiceCnpj?: unknown;

    product?: ProductRmaModelMf;
    changes?: ChangeRmaModelMf[];
    status?: {
        code: string;
        description?: string;
    };
    technicalReport?: unknown;
    failureReported?: string;
    factoryWarranty?: boolean;
    serviceWarranty?: boolean;
    badUse?: boolean;
    contract?: {
        code?: number;
    };
    budget?: WorkOrderBudgerModelMf;
    rma?: {
        number?: number;
    };
    accessory?: string;
    entryInvoice?: number;
    saleDate?: string;
    flagApproved?: number;
    courierName?: unknown;
    courierRegisterNumber?: unknown;
    trackingCode?: unknown;
    invoiceDate?: string;
    issued?: string;
};

export type BudgetItemsMf = {
    amount: number;
    code: string;
    currency: number;
    description: string;
    flagApproved: number;
    ncm: string;
    netValue: number;
    number: string;
    optional: number;
    ottp: string;
    quantity: number;
    reason: {
        code: string;
        description: string;
    };
    serviceType: number;
    tax: TaxModelMf;
    unitaryValue: number;
};

export type TaxModelMf = {
    aliquotICMS: number;
    aliquotIPI: number;
    aliquotISS: number;
    aliquotST: number;
    cofins: number;
    icms: number;
    ipi: number;
    iss: number;
    pis: number;
    st: number;
};

export type RMAStatusMf = {
    RMA_ID: number;
    STATUS: string;
};

export type RmaEquipmentMf = {
    Id: number;
    SerialNumber: number;
    PartNumber: number;
    StatusId: number;
};
export type RmaCustomerCAMf = {
    Name: string;
    Contact: string;
    City: string;
    State: string;
    Neighborhood: string;
    Street: string;
    Complement: string;
    Country: string;
    ZipCode: string;
    Number: number;
};
export type RmaResultModelCAMf = {
    rmaId: number;
    suportLevel: number;
    user: string;
    statusId: number;
    qtdItems: number;
};

export type RmaRequestMf = {
    text: string;
    value: any;
};
export type RmaStatusCAMf = {
    value: number;
    text: string;
    color: 'red' | 'yellow' | 'orange' | 'green' | 'blue' | 'grey';
    toRma: true | false;
    description: String;
};
export type RmaSupportLevelCAMf = {
    value: number;
    color: 'green';
    text: string;
    support: string[];
};
export type TrueFalseMf = {
    value: boolean;
    text: string;
};

export type SerialNumberMf = {
    code: string;
    contractNumber: string;
    contractValidity: string;
    description: string;
    factoryWarranty: string;
    flagHasContract: boolean;
    flagHasFactoryWarranty: boolean;
    flagHasServiceWarranty: boolean;
    partNumber: string;
    partNumberModel: string;
    salesInvoice: string;
    serialNumber: string;
    serviceWarranty: string;
};
